export default __webpack_public_path__ + "static/media/Papierkorb.d01be652.svg";